export const reportTypes = {
  PowerBI: "PowerBI",
  Tabla: "Tabla",
  Grafico: "Grafico",
  Mapa: "Mapa",
  URL: "Url",
};

export const tipoClonacion = {
  Users: 0,
  Groups: 1,
  Both: 2
};
